import React from 'react';
import { Input, type InputProps } from '@planne-software/uni/Input';

import { applyMask, type masks } from '@src/common/masks';

export type MaskedFieldProps = {
  mask: keyof typeof masks;
  name: string;
  label: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  required?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  fullWidth?: boolean;
  type?: React.HTMLInputTypeAttribute;
  inputMode?: InputProps['inputMode'];
};

export const MaskedField = (props: MaskedFieldProps) => {
  const {
    mask,
    name,
    label,
    value,
    onChange,
    onBlur,
    error,
    helperText,
    disabled,
    required,
    inputRef,
    fullWidth,
    type = 'text',
    inputMode = 'numeric',
  } = props;

  return (
    <Input
      type={type}
      inputMode={inputMode}
      name={name}
      id={name}
      label={label}
      value={value ?? ''}
      onChange={onChange}
      onBlur={onBlur}
      mask={(nextValue) => applyMask(nextValue, mask)}
      error={error}
      helperText={helperText}
      disabled={disabled}
      required={required}
      inputRef={inputRef}
      size='medium'
      fullWidth={fullWidth}
    />
  );
};

export default MaskedField;
